export const parametersGeneralNames = {
  '1': {
    name: 'Geral',
    tab0: {
      '1': 'Geral',
      '2': 'Pedido de venda',
      '3': 'Pedido de compra',
      '4': 'Vendedor',
      '5': 'Produto',
      '6': 'Nfe',
      '7': 'Nfe Serviço',
      '8': 'Fiscal',
      '9': 'Cta. Receber',
      '10': 'Tabela de preço',
      '11': 'Balanço',
      '12': 'Pedido de encomenda',
      '13': 'Ordem de produção',
    }
  },
  '2': {
    name: 'Futura PDV'
  },
  '3': {
    name: 'Futura Loja virtual'
  },
  'G': {
    name: 'Futura Gourmet',
    tab0: {
      '11': 'Restaurante'
    }
  },
  'OS': {
    name: 'Futura OS'
  },
  'C': {
    name: 'Futura Consignação'
  }
}